const CMSExpirationsServices = (instance) => {

    const getExpirationsData = () => instance.get('expirations');

    return {
        getExpirationsData,
    };
};
export default CMSExpirationsServices;